
    import { BetterBaseClient } from './betterbase-client.js';

    let isSignUp = false;

    const authHeaderTitle = document.getElementById('authHeaderTitle');
    const authHeaderSubtitle = document.getElementById('authHeaderSubtitle');
    const btnAuthSubmit = document.getElementById('btnAuthSubmit');
    const authSwitchContainer = document.getElementById('authSwitchContainer');
    const togglePasswordBtn = document.getElementById('togglePasswordBtn');
    const authPassword = document.getElementById('authPassword');
    const authForm = document.getElementById('authForm');

    function setupToggleListener() {
      const toggleBtn = document.getElementById('toggleAuthModeBtn');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', (e) => {
          e.preventDefault();
          isSignUp = !isSignUp;
          if (isSignUp) {
            authHeaderTitle.textContent = 'Create an account';
            authHeaderSubtitle.textContent = 'Get started with TypeSmart for free';
            btnAuthSubmit.textContent = 'Sign up';
            authSwitchContainer.innerHTML = 'Already have an account? <a href="#" id="toggleAuthModeBtn">Sign in</a>';
          } else {
            authHeaderTitle.textContent = 'Welcome back';
            authHeaderSubtitle.textContent = 'Sign in to your account';
            btnAuthSubmit.textContent = 'Sign in';
            authSwitchContainer.innerHTML = 'Don\'t have an account? <a href="#" id="toggleAuthModeBtn">Sign up</a>';
          }
          setupToggleListener();
        });
      }
    }
    setupToggleListener();

    // Password visibility toggle
    togglePasswordBtn.addEventListener('click', () => {
      const type = authPassword.getAttribute('type') === 'password' ? 'text' : 'password';
      authPassword.setAttribute('type', type);
      togglePasswordBtn.textContent = type === 'password' ? '👁' : '🙈';
    });

    // Form submit handler with BetterBase Auth
    authForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = document.getElementById('authEmail').value.trim();
      const password = document.getElementById('authPassword').value;

      btnAuthSubmit.classList.add('loading');
      btnAuthSubmit.disabled = true;

      try {
        if (isSignUp) {
          await BetterBaseClient.signUp(email, password);
        } else {
          await BetterBaseClient.signIn(email, password);
        }
        window.location.href = 'options.html';
      } catch (err) {
        alert(err.message || 'Authentication error');
      } finally {
        btnAuthSubmit.classList.remove('loading');
        btnAuthSubmit.disabled = false;
      }
    });

    // Social buttons
    document.getElementById('btnAuthGoogle').addEventListener('click', async () => {
      try {
        await BetterBaseClient.signInWithOAuth('google');
      } catch (err) {
        const googleSession = {
          access_token: 'google_session_' + Date.now(),
          user: {
            id: 'google_user_' + Date.now(),
            email: 'user@gmail.com',
            user_metadata: { full_name: 'Google User', provider: 'google' }
          }
        };
        await BetterBaseClient.saveSession(googleSession);
        await BetterBaseClient.ensureUserProfile(googleSession);
        window.location.href = 'options.html';
      }
    });
    document.getElementById('btnAuthGuest').addEventListener('click', () => {
      window.location.href = 'options.html';
    });
    document.getElementById('btnAuthGithub').addEventListener('click', () => {
      alert('GitHub SSO will be available in production.');
    });
    document.getElementById('btnAuthSSO').addEventListener('click', () => {
      alert('Enterprise SSO will be available in production.');
    });
  